import posthog from "posthog-js";

const DEFAULT_HOST = "https://us.i.posthog.com";

let initialized = false;

const resolveConfig = () => {
  const tenantHead =
    (typeof window !== "undefined" && window.__TENANT__ && window.__TENANT__.head) || {};
  const key = process.env.REACT_APP_POSTHOG_KEY || tenantHead.posthogKey || null;
  const host =
    process.env.REACT_APP_POSTHOG_HOST || tenantHead.posthogHost || DEFAULT_HOST;
  return { key, host };
};

export const initPostHog = () => {
  if (initialized || typeof window === "undefined") return;
  // Global Privacy Control: no session recording or event stream for this browser.
  if (window.navigator && window.navigator.globalPrivacyControl === true) return;
  const { key, host } = resolveConfig();
  if (!key) return;

  try {
    posthog.init(key, {
      api_host: host,
      defaults: "2026-05-30",
      capture_pageview: true,
      autocapture: true,
      capture_heatmaps: true,
      persistence: "localStorage+cookie",
    });
    initialized = true;
  } catch {
    initialized = false;
  }
};

export const isPostHogEnabled = () => initialized;

export const identifyUser = (userId, properties = {}) => {
  if (!initialized || !userId) return;
  posthog.identify(String(userId), properties);
};

export const captureEvent = (eventName, properties = {}) => {
  if (!initialized || !eventName) return;
  posthog.capture(eventName, properties);
};

export const registerSuperProperties = (properties = {}) => {
  if (!initialized) return;
  posthog.register(properties);
};

export const setGroup = (groupType, groupKey, properties = {}) => {
  if (!initialized || !groupType || !groupKey) return;
  posthog.group(String(groupType), String(groupKey), properties);
};

export const resetPostHog = () => {
  if (!initialized) return;
  posthog.reset();
};

export default posthog;
